// extracted by mini-css-extract-plugin
export var notificationHost = "_go-0";